import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PlessDialogService } from '../pless-dialog-service';
import { PlessRequest } from '../vo/pless-request.model';
import { PlessDownloadService } from './pless-download.service';

@Injectable({
  providedIn: 'root'
})
export class PlessJsonDownloadService extends PlessDownloadService {

  constructor(protected http: HttpClient, protected dialogService: PlessDialogService) {
    super(http, dialogService);
  }

  executeSend(_: string, body: PlessRequest|any): Promise<any> {
    let data = (body instanceof PlessRequest) ? 'jsonData=' + JSON.stringify(body) : undefined;
    const csrfToken = document.cookie.split('; ').find(row => row.startsWith('XSRF-TOKEN='));
    const jwt = document.cookie.split('; ').find(row => row.startsWith('PEACE_JWT='));

    return this.http.post(this.serviceInfo.url, data, {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-XSRF-TOKEN': csrfToken ? csrfToken.split('=')[1] : '',
        Authorization: jwt ? 'Bearer ' + jwt.split('=')[1] : '',
      }),
      responseType: 'blob',
      withCredentials: true
    }).toPromise();
  }
}
